import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { searchAgainApplications as searchAgainApplicationsInst } from '../shared/ApplicationSearch'
import { instanceName } from './constants'

export const searchAgainApplications = (resolve?: Function, reject?: Function) => searchAgainApplicationsInst(instanceName, resolve, reject)

export default Loadable(() => import('./ApplicationSearchGeneral'))
